import { IconShieldSuperAdmin } from '@shares/DMPIcon';
import { Icon, Tabs } from 'antd';
import { useState } from 'react';
import CommonTypeProps from '../../../../common/CommonTypeProps';
import DashboardPageLayoutV2 from '../../../../layout/dashboard/DashboardPageLayoutV2';
import InternalPermissionComponentV2 from '../../internal_permission/InternalPermissionComponentV2';
import SuperPermissionComponentV2 from '../SuperPermissionComponentV2';
import React from 'react';

export type TTabPermission = 'permission' | 'internal-permission';

type TabPermissionProps = CommonTypeProps & {};

const TabPermission = (props: TabPermissionProps) => {
  const [tab, setTab] = useState<TTabPermission>('permission');

  const renderContentLayout = () => {
    return (
      <Tabs
        onChange={(tab: TTabPermission) => setTab(tab)}
        activeKey={tab}
        defaultActiveKey={tab}
        animated={false}
        hideAdd
        destroyInactiveTabPane
      >
        <Tabs.TabPane tab={'Permission'} key="permission">
          <SuperPermissionComponentV2 {...props} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={'Internal Permission'} key="internal-permission">
          <InternalPermissionComponentV2 {...props} />
        </Tabs.TabPane>
      </Tabs>
    );
  };

  const renderRight = () => {
    if (tab === 'permission') {
      return <></>;
    }

    if (tab === 'internal-permission') {
      return <></>;
    }

    return <></>;
  };

  return (
    <DashboardPageLayoutV2
      props={props}
      selectedLeftNavStandard="permission"
      selectedSubMenuStandard="console-super"
      breadcrumbItemsStandard={[
        {
          title: 'Home',
          path: '/',
        },
        {
          title: 'Super Admin',
        },
        {
          title: 'Permission',
        },
      ]}
      breadcrumbItemsModern={[
        {
          title: 'Account',
          path: '/',
        },
        {
          title: 'Super Admin',
        },
        {
          title: 'Permission',
        },
      ]}
      pageTitle="Supper Admin"
      renderContentLayout={renderContentLayout}
      metaTitle={props.ui.meta.title}
      pageTitleIcon={<Icon component={IconShieldSuperAdmin} />}
      renderRight={renderRight}
    />
  );
};

export default TabPermission;
